import { render, staticRenderFns } from "./page-view-hr-report.vue?vue&type=template&id=0b186e41&scoped=true"
import script from "./page-view-hr-report.vue?vue&type=script&lang=js"
export * from "./page-view-hr-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b186e41",
  null
  
)

export default component.exports